import axios from 'axios'
import store from '@/store'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || '/api',
  timeout: 30000,
  withCredentials: false, // 开发环境不需要携带cookie
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    const token = store.getters.getToken
    if (token) {
      config.headers['Token'] = token
      config.headers['Authorization'] = token
    }
    return config
  },
  error => Promise.reject(error)
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    const statusCode = res.status || res.code
    
    // 成功响应
    if (statusCode == 1) {
      return res
    }
    
    // 处理业务错误
    if (statusCode == 401) {
      // 检查是否是微信授权场景（包含need_auth和auth_url）
      if (res.data && res.data.need_auth && res.data.auth_url) {
        // 微信授权场景，将授权信息传递给上层
        const error = new Error(res.message || res.msg || '需要微信授权')
        error.code = res.code
        error.status = res.status
        error.data = res.data
        error.msg = res.msg || res.message // 添加msg字段
        error.needAuth = true
        error.authUrl = res.data.auth_url
        error.orderNo = res.data.order_no
        return Promise.reject(error)
      }
    }
    
    // 构建错误对象，包含完整的错误信息
    const error = new Error(res.message || res.msg || 'Error')
    error.code = res.code
    error.status = res.status
    error.data = res.data
    error.msg = res.msg || res.message // 添加msg字段，确保组件可以访问到错误信息
    return Promise.reject(error)
  },
  error => {
    let message = '网络错误，请稍后重试'
    
    if (error.response) {
      const status = error.response.status
      const data = error.response.data
      
      // 特殊处理：如果是401且包含微信授权信息
      if (status === 401 && data && data.data && data.data.need_auth && data.data.auth_url) {
        const authError = new Error(data.msg || data.message || '需要微信授权')
        authError.code = data.code || 401
        authError.status = status
        authError.data = data.data
        authError.msg = data.msg || data.message // 添加msg字段
        authError.needAuth = true
        authError.authUrl = data.data.auth_url
        authError.orderNo = data.data.order_no
        return Promise.reject(authError)
      }
      
      // 处理401未授权错误 - 弹出登录框
      if (status === 401) {
        store.commit('SHOW_LOGIN_MODAL')
        // 清除用户信息
        store.commit('CLEAR_USER')
      }
      
      const errorMap = {
        400: '请求参数错误',
        401: '未授权，请重新登录',
        403: '拒绝访问',
        404: '请求的资源不存在',
        500: '服务器内部错误',
        502: '网关错误',
        503: '服务不可用',
        504: '网关超时'
      }
      message = errorMap[status] || `连接错误${status}`
      
      // 构建错误对象，附加状态码信息
      const apiError = new Error(message)
      apiError.status = status
      apiError.msg = data?.msg || data?.message || message // 优先使用后端返回的错误信息
      apiError.response = error.response
      return Promise.reject(apiError)
    } else if (error.request) {
      message = '网络连接失败，请检查网络'
    } else {
      message = error.message || '请求失败'
    }
    
    const networkError = new Error(message)
    networkError.msg = message // 添加msg字段
    return Promise.reject(networkError)
  }
)

export default service 